export function hexToRgba(hex: string, transparencyPercentage: number): string {
    // Remove the '#' symbol from the hex code if present
    hex = hex.replace("#", "");

    // Convert the hex values to decimal
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Create the RGBA string
    return `rgba(${r}, ${g}, ${b}, ${transparencyPercentage})`;
}
